// Maps follow-up chat questionId values to short topic labels rendered above the
// progress bar in the FollowUpQuestionsSheetComponent. Unmapped questionIds fall
// back to "Question N". Add entries here as new follow-up questions are introduced.

const TOPIC_RESOLVERS: Record<string, () => string> = {
  pregnancyFollowup: (): string => $localize`:@@followupQuestionTitle_pregnancyFollowup:Safety Check`,
  firstFollowupImprovement: (): string => $localize`:@@followupQuestionTitle_firstFollowupImprovement:Progress Check-In`,
  followupFirstDiscomfort: (): string => $localize`:@@followupQuestionTitle_followupFirstDiscomfort:Skin discomfort`,
  followupFirstAcne: (): string => $localize`:@@followupQuestionTitle_followupFirstAcne:Concern Update`,
};

export function getFollowUpQuestionTopic(questionId: string | undefined, fallbackIndex: number): string {
  const resolver = questionId ? TOPIC_RESOLVERS[questionId] : undefined;
  if (resolver) return resolver();
  return $localize`:@@followUpQuestionFallback:Question ${fallbackIndex}`;
}
